import { Skeleton } from '@mui/material'
import { FC } from 'react'

import Logo from '@/assets/logo.svg?react'
import { Rule } from '@/components/core-v2'

import classes from './index.module.scss'

const LoadingItem = () => <Skeleton animation="pulse" height="53px" />

export const Loading: FC = ({ children }) => (
  <div className={classes.root}>
    <nav>
      <Logo className={classes.logo} />
      <Rule className={classes.rule} />
      <ul className={classes.linkList}>
        <LoadingItem />
        <LoadingItem />
        <LoadingItem />
        <LoadingItem />
        <LoadingItem />
        <LoadingItem />
      </ul>
    </nav>
    <div className={classes.childrenWrapper}>{children}</div>
  </div>
)
